module.exports = __webpack_public_path__ + "img/website_hover.f368a9c0.png";